import { Fragment } from 'preact';
import Skeleton from '../Skeleton';

const SalesSupport = () => {
  return (
    <Fragment>
      <Skeleton style={{ height: '80px', margin: 'auto' }} />
      <Skeleton style={{ height: '30px', margin: '24px 32px' }} />
      <Skeleton
        style={{
          height: '145px',
          border: '1px solid #dadce0',
          borderRadius: '8px',
          margin: '24px 32px',
        }}
        count={3}
      />
    </Fragment>
  );
};

export default SalesSupport;



// WEBPACK FOOTER //
// ./components/salesApp/skeletonScreens/SalesSupport.js